import {
    SET_ADD_STREAMER,
    SET_REMOVE_STREAMER,
    SET_WIPE_STREAMER
 } from './../../../constants/closeLoop/apmDashboard/streamerConstants';

const initialState = {
    streamers: []
};

export const streamer = (state=initialState, action) => {
    switch(action.type) {
        case SET_ADD_STREAMER:
            return {
                ...state,
                streamers: [
                    ...state.streamers,
                    action.payload
                ]
            }

        case SET_REMOVE_STREAMER:
            return {
                ...state,
                streamers: state.streamers.filter((item) => item !== action.payload)
            };

        case SET_WIPE_STREAMER:
            return {
                ...state,
                streamers: []
            }

        default:
            return state;
    }
};